import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import validid from 'validid';
import Select from 'react-select';
import { Common, PopUpBox } from '../../../../components';
import { styles, options, capitalizeName, alphabetOnly, numberWithNoCommas, detectMob, pad, alphabetAndNumberOnly, sw2Alert } from '../../../../utils/common';
import DropdownIndicator from '../../../../components/Common/DropdownIndicator';

import ReloadIcon from '../../../../assets/images/reload.svg';
import { actionGetConfig, actionGetStateDoc, actionMoneyComplete, actionMoneyForm1, actionMoneyForm2, actionMoneyForm3, actionSendOTP } from '../../../../store/application/actions';
import { useDispatch } from 'react-redux';
import { actionAddressConfig, actionApplicationIP } from '../../../../store/common/actions';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

function StepNoDocLoanForm1({ sessionId, onCompleted }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        setValue,
        register,
        handleSubmit,
        getValues,
        setError,
        setFocus,
        formState: { errors, isSubmitting },
    } = useForm();
    const [gender, setGender] = useState(null);
    const [isVisibleInvalidToken, setIsVisibleInvalidToken] = useState(false);
    const [hkid2, setHkid2] = useState('');
    const [checkBoxTime, setCheckBoxTime] = useState({})
    const [captcha, setCaptcha] = useState()
    const [url, setUrl] = useState(null)
    const [noDocLoanProduct, setNoDocLoanProduct] = useState(null)
    const [amount, setAmount] = useState(null)
    const [noDocLoanDisabled, setNoDocLoanDisabled] = useState(false)
    const [noDocLoanOptions, setNoDocLoanOptions] = useState(options.no_doc_loan_products);
    // 기존 2스텝(직장/소득) 입력값을 no-doc-loan 1스텝에서 함께 관리합니다.
    // const [mpf, setMpf] = useState(null);
    // 기존 3스텝(주소) 입력값을 no-doc-loan 1스텝에서 함께 관리합니다.
    const [estate, setEstate] = useState('');
    const [addressConfig, setAddressConfig] = useState(null);
    const [optionsDistrict, setOptionsDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState(null);
    const [isLoading, setLoading] = useState(false);

    const captchaRandom = () => {
        let originText = [];
        let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 4; i++) {
            let char = possible.charAt(Math.floor(Math.random() * possible.length));
            originText.push(char);
        }
        return originText.join('').toLocaleUpperCase()
    }

    useEffect(() => {
        setCaptcha(captchaRandom())
        getConfigUrl()
        getAddressConfig()
    }, [])

    const getConfigUrl = async () => {
        const response = await dispatch(actionGetConfig('MONEY_HERO_URL'));
        if (response?.sts_code === 0) {
            setUrl(JSON.parse(response?.content));
        }
    }

    const getAddressConfig = async () => {
        // 주소 지역/지구 선택 옵션은 기존 3스텝과 동일한 설정 API를 사용합니다.
        try {
            setLoading(true)
            const response = await dispatch(actionAddressConfig());
            if (response?.sts_code === 0) {
                setAddressConfig(response.content);
            } else {
                setAddressConfig({
                    area: options.area,
                    district_hk: options.district_hk,
                    district_kw: options.district_kw,
                    district_nt: options.district_nt,
                })
            }
            setLoading(false);
        } catch {
            setAddressConfig({
                area: options.area,
                district_hk: options.district_hk,
                district_kw: options.district_kw,
                district_nt: options.district_nt,
            })
            setLoading(false);
        }
    }

    const onSubmit = async (data) => {
        // check hkid valid
        if (!checkId(data?.hkid1, data?.hkid2, data?.hkid3)) {
            setFocus('hkid3')
            return
        };
        if (data?.captcha_code !== captcha) return;

        const responseDoc = await dispatch(actionGetStateDoc());
        const agree_doc = (responseDoc?.content ?? []).map(doc => {
            return {
                doc_type: doc.doc_type,
                doc_version: doc.doc_ver,
            }
        })
        const responseIP = await dispatch(actionApplicationIP());
        // form1 API로 보낼 기본 신청자/대출 정보입니다.
        const obj = {
            loan_amount: numberWithNoCommas(data?.loan_amount),
            loan_purpose: data?.loan_purpose,
            first_name: data?.first_name,
            last_name: data?.last_name,
            cust_gender: `0${gender}`,
            hkid: `${data?.hkid1}${data?.hkid2}${data?.hkid3}`,
            date_of_birth: `${data?.date_of_birth3}${pad(data?.date_of_birth2)}${pad(data?.date_of_birth1)}`,
            phone_number: data?.phone_number,
            email: data?.email,
            // education: data?.education,
            // marriage_status: data?.marriage_status,
            application_device: detectMob() ? 2 : 1,
            application_ip: responseIP?.ip,
            application_browser: window.navigator.userAgent,
            hkid_array: [data?.hkid1, data?.hkid2, data?.hkid3],
            check_box_1: data?.checkbox1,
            check_box_2: data?.checkbox2,
            check_box_1_time: moment(checkBoxTime?.check_box_1_time).format('YYYY-MM-DD HH:mm:ss'),
            check_box_2_time: moment(checkBoxTime?.check_box_2_time).format('YYYY-MM-DD HH:mm:ss'),
            agree_doc: JSON.stringify(agree_doc),
            session_id: sessionId,
            no_doc_loan_product: data?.no_doc_loan_product,
        };
        // 기존 step2.js에서 전송하던 직장/소득 정보를 1스텝 submit에서 함께 구성합니다.
        const form2Obj = {
            // business_type: data?.business_type,
            // job_type: data?.job_type,
            // position: data?.position,
            // employment_type: data?.employment_type,
            // receipt_way: data?.receipt_way,
            // monthly_income: numberWithNoCommas(data?.monthly_income),
            // payroll_method: data?.payroll_method,
            // mpf: mpf,
            session_id: sessionId,
            phone_number: data?.phone_number
        };
        // 기존 step3.js의 주소 조합 로직을 그대로 사용해 백엔드 주소 필드 형식을 맞춥니다.
        const district = optionsDistrict.find(t => t.value === districtValue?.value);
        const province = addressConfig.area.find(t => t.value === data?.area);
        let addr_line1 = '';
        if (data?.addr_line1_room) {
            addr_line1 = 'RM ' + (data?.addr_line1_room ?? '')
                .replace(new RegExp('ROOM', 'g'), '')
                .replace(new RegExp('RM', 'g'), '')
                .replace(new RegExp('FLAT', 'g'), '')
                .replace(new RegExp('FLT', 'g'), '')
                .replace(new RegExp('UNIT', 'g'), '').trim();
        }
        if (data?.addr_line1_floor) {
            addr_line1 += ' ' + (data?.addr_line1_floor ?? '')
                .replace(new RegExp('FLOOR', 'g'), '')
                .replace(new RegExp('F', 'g'), '')
                .replace(new RegExp("/F", 'g'), '').trim()
                + '/F';
        }
        if (data?.addr_line1_block) {
            addr_line1 += ' BLK ' + data?.addr_line1_block
                .replace(new RegExp('BLK', 'g'), '')
                .replace(new RegExp('BLOCK', 'g'), '')
                .replace(new RegExp("BL", 'g'), '').trim();
        }
        if (addr_line1.length > 49 || data?.estate?.length > 49) {
            return sw2Alert('地址欄位不可超過49個字元');
        };
        // X 표시된 주거 상세 항목은 화면에서 제외하고 백엔드 payload에는 빈 값으로 유지합니다.
        const form3Obj = {
            area: data?.area,
            city_id: district?.city_id,
            province_id: province?.province_id,
            city_id_tu: district?.tu_value,
            addr_line1: addr_line1,
            addr_line1_room: data?.addr_line1_room,
            addr_line1_floor: data?.addr_line1_floor,
            addr_line1_block: data?.addr_line1_block,
            addr_line2: data?.estate,
            property_type: null,
            number_living_with: null,
            property_owner: null,
            monthly_rent: '0',
            session_id: sessionId,
            phone_number: data?.phone_number
        };
        console.log(obj)

        if(data?.no_doc_loan_product !== 'genz'){

            if (!detectMob()) {
                // redirect to desktop page
                window.location.href = `${process.env.REACT_APP_HOME_URL}/application-desktop/`;
                return;
            }

            // redirect to otp page
            dispatch(
                actionSendOTP({
                    phone: data?.phone_number,
                }),
            );
            navigate('/application-otp', { state: { phone: data?.phone_number, no_doc_loan_data: obj} });
            return;
        }

        // no-doc-loan Gen Z는 1스텝 버튼에서 form1 -> form2 -> form3 -> complete를 순서대로 호출합니다.
        const responseForm1 = await dispatch(actionMoneyForm1(obj));
        console.log(responseForm1);
        if (responseForm1?.sts_code === 0) {
            const responseForm2 = await dispatch(actionMoneyForm2(form2Obj));
            console.log(responseForm2);
            if (responseForm2?.sts_code === 0) {
                const responseForm3 = await dispatch(actionMoneyForm3(form3Obj));
                console.log(responseForm3);
                if (responseForm3?.sts_code === 0) {
                    const application_date = moment().format('YYYY-MM-DDTHH:mm:ss') + "Z";
                    // 기존 3스텝 완료 API payload를 1스텝에서 조립해 완료 화면으로 바로 이동합니다.
                    const completeData = {
                        "application_date": application_date,
                        "application_ip": obj.application_ip,
                        "application_browser": obj.application_browser,
                        "application_device": obj.application_device,
                        "first_vist_date": application_date,
                        "apply_access_data": {
                            "access_data_id": "",
                            "access_referer": "No Referer",
                            "access_query": "string",
                            "utm_source": "NoDocLoan",
                            "session_id": sessionId
                        },
                        "application_form_data": {
                            "addr_line1": form3Obj.addr_line1,
                            "addr_line2": form3Obj.addr_line2,
                            "business_type": form2Obj.business_type,
                            "city_id": form3Obj.city_id,
                            "cust_gender": obj.cust_gender,
                            "date_of_birth": parseInt(obj.date_of_birth),
                            "education": obj.education,
                            "email": obj.email,
                            "employment_type": form2Obj.employment_type,
                            "first_name": obj.first_name,
                            "hkid": obj.hkid,
                            "job_type": form2Obj.job_type,
                            "last_name": obj.last_name,
                            "loan_amount": parseInt(obj.loan_amount),
                            "loan_purpose": obj.loan_purpose,
                            "marriage_status": obj.marriage_status,
                            "monthly_income": parseInt(form2Obj.monthly_income),
                            "monthly_rent": parseInt(form3Obj.monthly_rent),
                            "mpf": form2Obj.mpf,
                            "number_living_with": form3Obj.number_living_with,
                            "payroll_method": form2Obj.payroll_method,
                            "phone_number": obj.phone_number,
                            "position": form2Obj.position,
                            "property_owner": form3Obj.property_owner,
                            "property_type": form3Obj.property_type,
                            "province_id": form3Obj.province_id,
                            "receipt_way": form2Obj.receipt_way,
                            "check_box_1": obj.check_box_1,
                            "check_box_1_time": obj.check_box_1_time,
                            "check_box_2": obj.check_box_2,
                            "check_box_2_time": obj.check_box_2_time,
                            "agree_doc": JSON.parse(obj.agree_doc),
                            "loan_goods": "A0012"
                        }
                    }
                    const responseComplete = await dispatch(actionMoneyComplete(completeData));
                    console.log(responseComplete);
                    if (responseComplete?.sts_code === 0) {
                        // MoneyHero/index.js에서 이 값을 받아 중간 스텝을 건너뛰고 완료 페이지를 렌더링합니다.
                        onCompleted({ status: true, data: { form1: obj, form2: form2Obj, form3: form3Obj }, nextStepIndex: 3 })
                    }
                }
            }
        }
    };

    const checkId = (hkid1, hkid2, hkid3) => {
        if (hkid1 && hkid2 && hkid3) {
            return validid.hkid(`${hkid1}${hkid2}/${hkid3}`);
        }
        return false;
    };

    const beforeunload = (e) => {
        // const event = e || window.event;
        // if (event) {
        //     event.returnValue = 'Sure?';
        // }
        // return 'Sure?';
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener('beforeunload', beforeunload);
        return () => {
            window.removeEventListener('beforeunload', beforeunload);
        };
    }, []);

    const onHandleNoDocLoanProductChange = (e) => {
        setValue('no_doc_loan_product', e.value);
        setError('no_doc_loan_product', null);
        setNoDocLoanProduct(e);
        if (e.value === 'genz') {
            setValue('loan_amount', '5000');
        } else {

            if (!detectMob()) {
                // redirect to desktop page
                window.location.href = `${process.env.REACT_APP_HOME_URL}/application-desktop/`;
                return;
            }

            // redirect to OTP page or regester page
            const phone = getValues('phone_number');
            if (phone) {
                dispatch(
                    actionSendOTP({
                        phone: phone,
                    }),
                );
                navigate('/application-otp', { state: { phone: phone } });
            } else {
                navigate('/?open=register');
            }
        }
    }

    const onHandleYearChange = (year) => {
        if(year >= 1997 && year <= 2012){
            // genz selected
            setValue('no_doc_loan_product', 'genz');
            setError('no_doc_loan_product', null);
            setNoDocLoanProduct(options.no_doc_loan_products.find(t => t.value === 'genz'))
            setValue('loan_amount', '5000');
            setAmount(5000);
            setNoDocLoanDisabled(true);
            setNoDocLoanOptions(options.no_doc_loan_products);
        }else{
            // enable
            setValue('loan_amount', null);
            setAmount(null);
            setValue('no_doc_loan_product', null);
            setNoDocLoanProduct(null);
            setNoDocLoanDisabled(false);
            // rebuild options
            setNoDocLoanOptions(prev=>{
                let genzIndex = prev.findIndex(t=> t.value === 'genz');
                if(genzIndex > -1){
                    prev[genzIndex].isDisabled = true;
                }
                return prev;
            });
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {isVisibleInvalidToken && <PopUpBox.InvalidToken />}
            <Common.Loading isVisible={isSubmitting || isLoading} />
            <div className="bg-white lg:px-10">
                <div className="p-3 flex space-y-5 lg:space-y-0 max-md:flex-col">
                    <div className="lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray mb-2 font-bold">出生日期</p>
                        <Common.InputDate onChangeYear={onHandleYearChange} register={register} errors={errors} getValues={getValues} setValue={setValue} setError={setError} />
                    </div>
                    <div className="max-md:mb-6 lg:w-1/2 lg:pl-10 pl-0">
                        <p className="text-xl text-gray mb-2 font-bold">貸款產品</p>
                        <div className="flex items-center border-b border-primary">
                            <div className="w-full relative">
                                <Select
                                    placeholder="- 請選擇 -"
                                    className="w-full"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 0,
                                    })}
                                    styles={styles}
                                    {...register('no_doc_loan_product', { required: true })}
                                    onChange={onHandleNoDocLoanProductChange}
                                    options={noDocLoanOptions}
                                    isSearchable={false}
                                    isDisabled={noDocLoanDisabled}
                                    value={noDocLoanProduct}
                                    components={{ DropdownIndicator }}
                                />
                            </div>
                            {errors?.loan_purpose && errors?.loan_purpose?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        </div>
                    </div>
                </div>
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray mb-[18px] font-bold">貸款金額</p>
                        <Common.InputMoney disabled={noDocLoanDisabled} defaultValue={amount} setValue={setValue} register={register} title="loan_amount" setError={setError} errors={errors} />
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray mb-2 font-bold">貸款目的</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('loan_purpose', { required: true })}
                                onChange={(e) => {
                                    setValue('loan_purpose', e.value);
                                    setError('loan_purpose', null);
                                }}
                                options={options.loan_purpose_no_doc_loan}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.loan_purpose && errors?.loan_purpose?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl font-bold text-gray">英文姓名</p>
                        <p className="text-xs text-gray1 mb-2">需與身份證上的名字相同</p>
                        <div className="flex border-b border-primary mb-2">
                            <p className="text-gray1 mb-2">姓氏：</p>
                            <input {...register('last_name', {
                                required: true,
                                onChange: (e) => {
                                    const value = alphabetOnly(e?.target?.value + '')
                                    console.log(value);
                                    setValue('last_name', value.toUpperCase())
                                }
                            })} className="flex-1 px-2 outline-none text-primary" placeholder="" />
                        </div>
                        {errors?.last_name && errors?.last_name?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        <div className="flex border-b border-primary">
                            <p className="text-gray1 mb-2">名字：</p>
                            <input {...register('first_name', {
                                required: true,
                                onChange: (e) => {
                                    const value = alphabetOnly(e?.target?.value + '')
                                    setValue('first_name', capitalizeName(value))
                                }
                            })} className="flex-1 px-2 outline-none text-primary" placeholder="" />
                        </div>
                        {errors?.first_name && errors?.first_name?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <div className="max-md:mb-6 w-full lg:pr-10">
                            <p className="text-xl font-bold text-gray mb-[22px]">香港身份證號碼</p>
                            <div className="flex items-center">
                                <input tabIndex={-1} maxLength={2} {...register('hkid1', {
                                    required: true, onChange: (e) => {
                                        setValue('hkid1', alphabetOnly(e.target.value.toUpperCase().replace(' ', '')))
                                    }
                                })} className="px-2 outline-none border-b text-primary w-1/3 text-center" placeholder="A" />
                                <input tabIndex={-1}
                                    maxLength={6}
                                    {...register('hkid2', { required: true })}
                                    value={hkid2}
                                    onChange={(e) => setHkid2(e.target.value.replace(/[^0-9]/g, ''))}
                                    className="px-2 outline-none text-primary border-b w-full text-center ml-2 mr-2 border-primary"
                                    placeholder="123456"
                                />
                                <div className="border-b border-primary text-center">
                                    <span className="text-primary">(</span>
                                    <input tabIndex={-1} maxLength={1} {...register('hkid3', {
                                        required: true,
                                        onChange: (e) => {
                                            setValue('hkid3', alphabetAndNumberOnly(e.target.value.toUpperCase().replace(' ', '')))
                                        }
                                    })} className="px-1 outline-none text-primary w-3/4 text-center" placeholder="3" />
                                    <span className="text-primary">)</span>
                                </div>
                            </div>
                            {(errors?.hkid1 || errors?.hkid2 || errors?.hkid3) &&
                                (errors?.hkid1?.type === 'required' || errors?.hkid2?.type === 'required' || errors?.hkid3?.type === 'required') && <span className="text-10 text-red-500">*必填</span>}
                            {(getValues('hkid1') && getValues('hkid2') && getValues('hkid3') && !checkId(getValues('hkid1'), getValues('hkid2'), getValues('hkid3'))) &&
                                (!(errors?.hkid1 || errors?.hkid2 || errors?.hkid3) ||
                                    !(errors?.hkid1?.type === 'required' || errors?.hkid2?.type === 'required' || errors?.hkid3?.type === 'required')) && (
                                    <span className="text-sm text-red-500">*請輸入正確的身份證號碼</span>
                                )}
                        </div>
                        <div className="relative mt-3">
                            <div className='flex space-x-10 max-md:justify-center'>
                                {options.genders.map(item => {
                                    return (
                                        <div {...register('gender', { required: true })} key={item.value} onClick={() => {
                                            setValue('gender', item.value);
                                            setGender(item.value)
                                            setError('gender', null);
                                        }} className={`w-24 h-12 cursor-pointer border text-gray1 border-primary rounded-md flex justify-center items-center ${gender === item.value ? 'bg-primary text-white' : 'bg-white'}`}>
                                            {item.label}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        {errors?.gender && errors?.gender?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray mb-2 font-bold">手提電話</p>
                        <div className="flex items-center border-b border-primary">
                            <input maxLength={8} placeholder='(+852)' inputMode={'numeric'} {...register('phone_number',
                                {
                                    required: true,
                                    maxLength: 8,
                                    pattern: /^[0-9,]{8}$/,
                                    onChange: (e) => {
                                        setValue('phone_number', numberWithNoCommas(e?.target?.value))
                                        setError('phone_number', null)
                                    }
                                })} className="flex-1 px-2 outline-none w-full bg-white text-primary" />
                        </div>
                        {errors?.phone_number && errors?.phone_number?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        {errors?.phone_number && errors?.phone_number?.type === 'pattern' && <span className="text-10 text-red-500">*請輸入正確的手提電話號碼</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray font-bold">電郵地址</p>
                        <Common.InputEmail register={register} setValue={setValue} onChange={(email) => setValue('email', email)} getValues={getValues} setError={setError} ></Common.InputEmail>
                        <input type='hidden' {...register('email', {
                            required: true,
                            pattern: /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\]\\.,;:\s@\\"]+\.)+[^<>()[\]\\.,;:\s@\\"]{2,})$/g,
                        })}
                        />
                        {errors?.email && errors?.email?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        {errors.email && errors.email.type === 'pattern' && <span className="text-10 text-red-500">*請輸入正確的電郵</span>}
                    </div>
                </div>

                {/* 캡쳐 항목 주석 처리: 學歷 / 婚姻狀態
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray mb-2 font-bold">學歷</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('education', { required: true })}
                                onChange={(e) => {
                                    setValue('education', e.value);
                                    setError('education', null);
                                }}
                                options={options.education}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.education && errors?.education?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray mb-2 font-bold">婚姻狀態</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('marriage_status', { required: true })}
                                onChange={(e) => {
                                    setValue('marriage_status', e.value);
                                    setError('marriage_status', null);
                                }}
                                options={options.marriage_status}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.marriage_status && errors?.marriage_status?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                */}
                {/* 기존 step2.js의 직장/소득 입력 항목을 no-doc-loan 1스텝으로 이동했습니다. */}
                {/* 캡쳐 항목 주석 처리: 工作類型 / 業務類型
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-2">工作類型</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('job_type', { required: true })}
                                onChange={(e) => {
                                    setValue('job_type', e.value);
                                    setError('job_type', null);
                                }}
                                options={options.job_type}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.job_type && errors?.job_type?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray font-bold mb-2">業務類型</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('business_type', { required: true })}
                                onChange={(e) => {
                                    setValue('business_type', e.value);
                                    setError('business_type', null);
                                }}
                                options={options.business_type}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.business_type && errors?.business_type?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                */}
                {/* 캡쳐 항목 주석 처리: 職位 / 受聘形式
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-2">職位</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('position', { required: true })}
                                onChange={(e) => {
                                    setValue('position', e.value);
                                    setError('position', null);
                                }}
                                options={options.position}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.position && errors?.position?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray font-bold mb-2">受聘形式</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('employment_type', { required: true })}
                                onChange={(e) => {
                                    setValue('employment_type', e.value);
                                    setError('employment_type', null);
                                }}
                                options={options.employment_type}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.employment_type && errors?.employment_type?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                */}
                {/* 캡쳐 항목 주석 처리: 出糧方式 / 月收入
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-2">出糧方式</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('receipt_way', { required: true })}
                                onChange={(e) => {
                                    setValue('receipt_way', e.value);
                                    setError('receipt_way', null);
                                }}
                                options={options.receipt_way}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.receipt_way && errors?.receipt_way?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray font-bold mb-2">月收入</p>
                        <Common.InputMoney zeroAllow={true} placeholder=" " register={register} title="monthly_income" setError={setError} errors={errors} />
                    </div>
                </div>
                */}
                {/* 캡쳐 항목 주석 처리: 支薪方式 / MPF強積金
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-2">支薪方式</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('payroll_method', { required: true })}
                                onChange={(e) => {
                                    setValue('payroll_method', e.value);
                                    setError('payroll_method', null);
                                }}
                                options={options.payroll_method}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.payroll_method && errors?.payroll_method?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray font-bold mb-2">MPF強積金</p>
                        <div className="relative">
                            <div className='flex space-x-10 max-md:justify-center'>
                                {options.mpf.map(item => {
                                    return (
                                        <div {...register('mpf', { required: true })} key={item.value} onClick={() => {
                                            setValue('mpf', item.value);
                                            setMpf(item.value)
                                            setError('mpf', null);
                                        }} className={`w-24 h-12 cursor-pointer border text-gray1 border-primary rounded-md flex justify-center items-center ${mpf === item.value ? 'bg-primary text-white' : 'bg-white'}`}>
                                            {item.label}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        {errors?.mpf && errors?.mpf?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                */}
                {/* 기존 step3.js의 주소 입력 항목 중 필수 주소 정보만 no-doc-loan 1스텝으로 이동했습니다. */}
                <div className='p-3 flex max-md:flex-col'>
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-2">住宅地址</p>
                        <p className="text-xl text-gray font-bold mb-2">區域</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('area', { required: true })}
                                onChange={(e) => {
                                    setValue('area', e.value);
                                    setError('area', null);
                                    setDistrictValue(null);
                                    setValue('district', null)
                                    switch (e.value) {
                                        case 'HK':
                                            setOptionsDistrict(addressConfig.district_hk);
                                            break;
                                        case 'KLN':
                                            setOptionsDistrict(addressConfig.district_kw);
                                            break;
                                        case 'NT':
                                            setOptionsDistrict(addressConfig.district_nt);
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                                options={addressConfig?.area}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors.area && errors.area.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10 lg:pt-9">
                        <p className="text-xl text-gray font-bold mb-2">地區</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('district', { required: true })}
                                value={districtValue}
                                onChange={(e) => {
                                    setDistrictValue(e)
                                    setValue('district', e?.value)
                                    setError('district', null)
                                }}
                                options={optionsDistrict}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors.district && errors.district.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                <div className='p-3 flex max-md:flex-col'>
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10 flex">
                        <div className="flex flex-col pr-2">
                            <p className="text-gray font-bold mb-2">單位</p>
                            <div className="flex items-center border-b border-primary">
                                <input
                                    {...register('addr_line1_room', { required: true })}
                                    onChange={(e) => {
                                        const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                        setValue('addr_line1_room', value)
                                    }}
                                    className="flex-1 px-1 outline-none text-primary w-full"
                                    placeholder="Room/Flat/Unit"
                                />
                            </div>
                            {errors.addr_line1_room && errors.addr_line1_room.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        </div>
                        <div className="flex flex-col px-2">
                            <p className="text-gray font-bold mb-2">樓層</p>
                            <div className="flex items-center border-b border-primary">
                                <input
                                    {...register('addr_line1_floor', { required: false })}
                                    onChange={(e) => {
                                        const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                        setValue('addr_line1_floor', value)
                                    }}
                                    className="flex-1 px-1 outline-none text-primary w-full"
                                    placeholder="Floor"
                                />
                            </div>
                            {errors.addr_line1_floor && errors.addr_line1_floor.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        </div>
                        <div className="flex flex-col pl-2">
                            <p className="text-gray font-bold mb-2">座數/大廈</p>
                            <div className="flex items-center border-b border-primary">
                                <input
                                    {...register('addr_line1_block', { required: false })}
                                    onChange={(e) => {
                                        const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                        setValue('addr_line1_block', value)
                                    }}
                                    className="flex-1 px-1 outline-none text-primary w-full"
                                    placeholder="Block"
                                />
                            </div>
                            {errors.addr_line1_block && errors.addr_line1_block.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        </div>
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-gray font-bold mb-2">屋苑/街道</p>
                        <div className="flex items-center border-b border-primary">
                            <input
                                {...register('estate', { required: true })}
                                value={estate}
                                onChange={(e) => {
                                    const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                    setEstate(value)
                                    setValue('estate', value)
                                    setError('estate', null)
                                }}
                                className="flex-1 px-2 outline-none text-primary w-full"
                                placeholder="(E.g. HAPPY EST)"
                            />
                        </div>
                        {errors.estate && errors.estate.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                {/*
                X 표시 요청된 항목입니다. 추후 복구 가능하도록 JSX 주석으로만 비활성화했습니다.
                <div className='p-3 flex max-md:flex-col'>
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-2">房屋類型</p>
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray font-bold mb-2">同住人數</p>
                    </div>
                </div>
                <div className='p-3 flex max-md:flex-col'>
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-[16px]">持有人</p>
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray font-bold mb-2">每月房租</p>
                    </div>
                </div>
                */}
                <div className="py-6 px-4 mt-9">
                    <div className="flex mb-2">
                        <input type="checkbox" {...register('checkbox1', {
                            required: true,
                            onChange: (e) => {
                                const checked = e.target.checked
                                if (checked) {
                                    setCheckBoxTime(prev => {
                                        return { ...prev, check_box_1_time: new Date() }
                                    })
                                }
                            }
                        })} id="id-checkbox1" className="mr-2 mt-1 w-5 h-5 peer relative appearance-none border border-primary rounded-md cursor-pointer checked:bg-primary" />
                        <label htmlFor="id-checkbox1" className="text-gray1 flex-1">
                            本人聲明本人
                            <span className="text-primary">並非破產中</span>
                            人士，而本人並無意申請破產及據本人所知現時並
                            <span className="text-primary">無任何有關本人破產呈請在進行中</span>。
                        </label>
                    </div>
                    <div className="flex">
                        <input type="checkbox" {...register('checkbox2', {
                            required: true,
                            onChange: (e) => {
                                const checked = e.target.checked
                                if (checked) {
                                    setCheckBoxTime(prev => {
                                        return { ...prev, check_box_2_time: new Date() }
                                    })
                                }
                            }
                        })} id="id-checkbox2" className="mr-2 mt-1 w-5 h-5 peer relative appearance-none border border-primary rounded-md cursor-pointer checked:bg-primary" />
                        <label htmlFor="id-checkbox2" className="text-gray1 flex-1">
                            本人確認為<span className="text-primary">香港永久性居民</span>並年齡為<span className="text-primary">18歲或以上人</span>士，本人已詳細閱讀並同意
                            <a href={`${process.env.REACT_APP_HOME_URL}/money-lenders-ordinance/`} className="text-primary underline" target="_blank" rel="noreferrer">
                                放債人條例
                            </a>
                            、
                            <a
                                href={`${process.env.REACT_APP_HOME_URL}/privacy-policy-and-personal-information-collection-statement/`}
                                className="text-primary underline"
                                target="_blank"
                                rel="noreferrer"
                            >
                                私隱政策及收集個人資料聲明
                            </a>
                            、
                            <a
                                href={`${process.env.REACT_APP_HOME_URL}/terms-and-conditions/`}
                                className="text-primary underline"
                                target="_blank"
                                rel="noreferrer"
                            >
                                私人貸款使用條款
                            </a>
                            及
                            <a href={`${process.env.REACT_APP_HOME_URL}/website-terms/`} className="text-primary underline" target="_blank" rel="noreferrer">
                                網站使用條款
                            </a>
                            ，亦同意 Cashing Pro Limited 有權向任何第三方人士索取有關本人的資料，包括向信貸資料機構查閱及提供本人的信貸記錄；亦同意 Cashing Pro Limited 經電話、短訊、WhatsApp、電子郵件通知本人有關貸款的服務信息。
                        </label>
                    </div>
                    {(errors.checkbox1 || errors.checkbox2) && (errors.checkbox1?.type === 'required' || errors.checkbox2?.type === 'required') && (
                        <span className="text-10 text-red-500">*請確認及勾選</span>
                    )}
                </div>
                {url?.is_show && <div className="px-3">
                    <a className="text-primary" href={url?.url}>{url.text}</a>
                </div>}
                <div className='flex space-x-2 justify-start items-end mt-9 p-3'>
                    <div>
                        <p className="text-xl text-gray mb-2 font-bold">驗證碼</p>
                        <div className="flex items-center border-b border-primary">
                            <input maxLength={4} {...register('captcha_code', {
                                required: true,
                                onChange: (e) => {
                                    setValue('captcha_code', e.target?.value)
                                    setError('captcha_code', null)
                                }
                            })} className="flex-1 px-2 outline-none w-full bg-white text-primary" />
                            {((errors?.captcha_code && errors?.captcha_code?.type === 'required') || (!!getValues('captcha_code') && getValues('captcha_code')?.length === 4 && getValues('captcha_code') !== captcha)) && <span className="text-10 text-red-500">*驗證碼錯誤</span>}
                        </div>
                    </div>
                    <div className='flex justify-center items-center w-24 h-8 bg-gray2'>
                        <span className='tracking-[0.5rem] text-gray1 font-bold'>{captcha}</span>
                    </div>
                    <div className="cursor-pointer" onClick={() => setCaptcha(captchaRandom())}>
                        <img src={ReloadIcon} alt='' />
                    </div>
                </div>
                <div className="flex justify-center mt-9 mb-4">
                    <button disabled={isSubmitting || isLoading} type="submit" className={`rounded-full text-white text-xl px-14 py-3 ${isSubmitting || isLoading ? 'bg-mercury' : 'bg-primary'} button1`}>
                        提交申請
                    </button>
                </div>
            </div>
        </form>
    );
}

export default StepNoDocLoanForm1;
